import React from 'react';
import './divider.css';

const Divider: React.FC = () => {
  return <div className='divider'></div>;
};

export default Divider;
